import { Priority } from "@a46-rss/shared";
import { ArticleListItem } from "../hooks/useArticles";

interface ArticleCardProps {
  article: ArticleListItem;
  onClick?: () => void;
}

const priorityClasses: Record<Priority, string> = {
  1: "priority-1",
  2: "priority-2",
  3: "priority-3",
  4: "priority-4",
  5: "priority-5",
};

const priorityLabels: Record<Priority, string> = {
  1: "最高",
  2: "高",
  3: "中",
  4: "低",
  5: "最低",
};

export default function ArticleCard({ article, onClick }: ArticleCardProps) {
  const priority = article.priority as Priority;

  return (
    <div
      className="bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow cursor-pointer p-4"
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          {/* タイトル */}
          <h3 className="text-base font-medium text-gray-900 truncate">
            {article.title}
          </h3>

          {/* メタ情報 */}
          <div className="mt-1 flex items-center space-x-3 text-sm text-gray-500">
            <span>{article.source_name}</span>
            <span>|</span>
            <span>
              {article.published_at
                ? new Date(article.published_at).toLocaleDateString("ja-JP")
                : "日付不明"}
            </span>
          </div>

          {/* サマリー */}
          {article.summary && (
            <p className="mt-2 text-sm text-gray-600 line-clamp-2">
              {article.summary}
            </p>
          )}
        </div>

        {/* 優先度バッジ */}
        <div className="ml-4 flex-shrink-0">
          <span className={`priority-badge ${priorityClasses[priority]}`}>
            P{priority} {priorityLabels[priority]}
          </span>
        </div>
      </div>

      {/* カテゴリ */}
      {article.categories && article.categories.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {article.categories.map((cat) => (
            <span
              key={cat.category_id}
              className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-blue-50 text-blue-700"
            >
              {cat.category_name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
